import React from 'react';
import classNames from 'classnames';

import { Button } from '@eventbrite/eds-button';
import { isSmallDown, isSmallWideDown } from '@eventbrite/eds-utils';
import { PAGE_SIZE_LG, PAGE_SIZE_MD, PAGE_SIZE_MIN } from '@eb/eds-pagination';
import { HAS_WINDOW } from '@eb/feature-detection';

export const scrollToTop = () => {
    if (HAS_WINDOW) {
        window.scrollTo(0, 0);
    }
};

export const getTabItems = (
    currentIndex,
    tabs,
    onClick,
    buttonPaths,
    isSmallType,
) =>
    tabs.map((name, index) => {
        const className = classNames(
            'tab-navigation__item eds-l-pad-hor-3 eds-l-sm-mar-hor-3 eds-l-sw-mar-hor-3 eds-l-pad-top-3',
            {
                'eds-l-pad-bot-2 eds-text-color--grey-900 tab-navigation__item--selected':
                    currentIndex === index,
                'eds-l-pad-bot-3': currentIndex !== index,
                'eds-text-bs': isSmallType,
            },
        );
        let tabButton = null;

        if (buttonPaths) {
            tabButton = (
                <Button
                    key={name}
                    style="none"
                    type="link"
                    href={buttonPaths[index]}
                    __containerClassName={className}
                    onClick={onClick.bind(this, index)}
                >
                    <span>{name}</span>
                </Button>
            );
        } else {
            tabButton = (
                <Button
                    key={name}
                    style="none"
                    __containerClassName={className}
                    onClick={onClick.bind(this, index)}
                >
                    <span>{name}</span>
                </Button>
            );
        }

        return tabButton;
    });

export const getPaginatorSize = () => {
    if (isSmallDown()) {
        return PAGE_SIZE_MIN;
    }

    if (isSmallWideDown()) {
        return PAGE_SIZE_MD;
    }

    return PAGE_SIZE_LG;
};
